import {metadaApi} from '@dms/api/base';

import {
  DeleteCustomerServiceContractArg,
  DeleteCustomerServiceContractResponse,
  GetCustomerServiceContractResponse,
  GetCustomerServiceContractArg,
  PatchCustomerServiceContractArg,
  PatchCustomerServiceContractResponse,
  PostCustomerServiceContractArg,
  PostCustomerServiceContractResponse,
  GetServiceContractsResponse,
  GetServiceContractsArg,
} from './types';

export const metadaCustomerServiceContractApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    postCustomerServiceContract: build.mutation<
      PostCustomerServiceContractResponse,
      PostCustomerServiceContractArg
    >({
      query: (queryArg) => ({
        url: `/core/v1/customer/${queryArg.customerId}/service-contract`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'customerServiceContracts', id: queryArg.customerId},
      ],
    }),
    getCustomerServiceContract: build.query<
      GetCustomerServiceContractResponse,
      GetCustomerServiceContractArg
    >({
      query: (queryArg) => ({
        url: `/core/v1/customer/${queryArg.customerId}/service-contract/${queryArg.serviceContractId}`,
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'customerServiceContract', id: queryArg.serviceContractId},
      ],
    }),
    deleteCustomerServiceContract: build.mutation<
      DeleteCustomerServiceContractResponse,
      DeleteCustomerServiceContractArg
    >({
      query: (queryArg) => ({
        url: `/core/v1/customer/${queryArg.customerId}/service-contract/${queryArg.serviceContractId}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'customerServiceContract', id: queryArg.serviceContractId},
        {type: 'customerServiceContracts', id: queryArg.customerId},
      ],
    }),
    patchCustomerServiceContract: build.mutation<
      PatchCustomerServiceContractResponse,
      PatchCustomerServiceContractArg
    >({
      query: (queryArg) => ({
        url: `/core/v1/customer/${queryArg.customerId}/service-contract/${queryArg.serviceContractId}`,
        method: 'PATCH',
        body: queryArg.body,
      }),
      invalidatesTags: (_result, _error, queryArg) => [
        {type: 'customerServiceContract', id: queryArg.serviceContractId},
      ],
    }),
    getServiceContracts: build.query<GetServiceContractsResponse, GetServiceContractsArg>({
      query: (queryArg) => ({
        url: `/core/v1/service-contract`,
        params: {
          customerId: queryArg.customerId,
          authorizationProfileId: queryArg.authorizationProfileId,
          onlyValid: queryArg.onlyValid ?? true,
        },
      }),
      providesTags: (_result, _error, queryArg) => [
        {type: 'customerServiceContracts', id: queryArg.customerId},
      ],
    }),
  }),
  overrideExisting: false,
});
export const {
  useGetCustomerServiceContractQuery,
  usePostCustomerServiceContractMutation,
  useDeleteCustomerServiceContractMutation,
  usePatchCustomerServiceContractMutation,
  useGetServiceContractsQuery,
} = metadaCustomerServiceContractApi;
